// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.auth-login-input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #eef5f4 inset;
  color: black;
  font-family: sans-serif;
}

input.auth-login-input:-webkit-autofill ~ label {
  transform: translateY(-125%);
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reusable/Form/styles/index.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":["input.auth-login-input:-webkit-autofill {\n  box-shadow: 0 0 0px 1000px #eef5f4 inset;\n  color: black;\n  font-family: sans-serif;\n}\n\ninput.auth-login-input:-webkit-autofill ~ label {\n  transform: translateY(-125%);\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
